import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import VProIcon from '../../icons/VProIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.bg.whiteOff1,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
  },
  backgroundWrapper: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 1,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'auto',
    padding: theme.spacing(4, 2),
  },
  footer: {
    zIndex: 2,
    position: 'relative',
    textAlign: 'center',
    color: theme.palette.primary.contrastText,
    bottom: theme.spacing(8)
  },
  footerInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
}));

export default function Authentication({ children }) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.backgroundWrapper}>
        <img
          src={`${process.env.REACT_APP_CDN_PATH}/assets/images/auth-bg.webp`}
          alt="Auth Background"
          className={classes.backgroundImage}
        />
      </Box>

      <Box className={classes.contentWrapper}>{children}</Box>

      <Box className={classes.footer}>
        <Box className={classes.footerInner}>
          <VProIcon primaryColor="#CE473C" secondaryColor="#81B5D5" width='160px' height='22px' />
          <Typography variant="body2">
            Created with art, craft, and intention by the team at Brandlive.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
